<template>
  <div class="illustration-pure-colors-content" id="identidade-visual-ilustracao-cores-puras" data-search-anchor>
    <div class="illustration-pure-colors-wrapper">
      <h1 class="illustration-pure-colors-title-span">{{ pureColorsTitleSpan }}</h1>
      <h1 class="illustration-pure-colors-title">{{ pureColorsTitle }}</h1>
    </div>

    <div class="description-illustration-pure-colors-wrapper">
      <div class="illustration-pure-colors-icon-wrapper">
        <p class="illustration-pure-colors-description">{{ pureColorsDescription1 }}</p>
      </div>
      <div class="illustration-pure-colors-icon-wrapper-important">
        <p class="importante" style="margin: 0;">{{ pureColorsDescription2 }}</p>
        <div class="illustration-pure-colors-importante">
          <IconCancel />
          <p class="illustration-pure-colors-description-sec3">{{ pureColorsDescription3 }}</p>
        </div>
      </div>
      <div class="illustration-pure-colors-icon-wrapper">
        <IconCheck />
        <p class="illustration-pure-colors-description-sec">{{ pureColorsDescription4 }}</p>
      </div>
    </div>

    <div
      class="illustration-pure-colors-card-item"
      :style="{ backgroundImage: `url(${ImageSrc})` }"
    ></div>
  </div>
</template>

<script lang="ts">
import IconCancel from '@/assets/icons/IconCancel.vue'
import IconCheck from '@/assets/icons/IconCheck.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import IllustrationPageMixin from '@/mixins/illustration-page-mixin'
import { IllustrationPageStore } from '@/store/visual-identity-page/illustration-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({ components: { IconCancel, IconCheck } })
export default class IllustrationPureColorsceneSection extends Mixins(IllustrationPageMixin) {
  illustrationPageStore: PageStoreContract = getModule(IllustrationPageStore, this.$store)

  get pureColorsTitleSpan(): string {
    return this.getElementTitle(4, 0)
  }

  get pureColorsTitle(): string {
    return this.getElementText(4, 0)
  }

  get pureColorsDescription1(): string {
    return this.getElementText(4, 1)
  }

  get pureColorsDescription2(): string {
    return this.getElementText(4, 2)
  }

  get pureColorsDescription3(): string {
    return this.getElementText(4, 3)
  }

  get pureColorsDescription4(): string {
    return this.getElementText(4, 4)
  }

  get ImageSrc(): string {
    return this.getElementMedia(4, 5)
  }

  async getIllustrationPage(): Promise<void> {
    await this.illustrationPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.illustrationPageStore.isLoading) {
      await this.getIllustrationPage()
    }
  }
}
</script>

<style lang="scss">
.illustration-pure-colors-content {
  display: grid;

  width: 100%;
  max-width: 1032px;
}

.illustration-pure-colors-wrapper {
  display: flex;
  align-items: center;
  height: 6vh;
  padding-top: 6.25rem;
  padding-bottom: 2rem;
}

.illustration-pure-colors-title-span {  
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  margin-right: 5px;
  color: #b3b3b3;
}

.illustration-pure-colors-title {  
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  color: #000000;
}

.description-illustration-pure-colors-wrapper {
  position: relative;
  align-items: flex-start;
  
  display: grid;
  grid-template-columns: 50% 50%;  
}

.illustration-pure-colors-icon-wrapper {
  display: flex;  
  align-items: center;
}

.illustration-pure-colors-description {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;

  margin: 0;
  width: 430px;
  white-space: pre-line;
}

.illustration-pure-colors-description-sec,
.importante,
.illustration-pure-colors-description-sec3 {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;  
  width: 378px;
}

.illustration-pure-colors-description-sec,
.illustration-pure-colors-description-sec3 {
  padding-left: 7px;
}


.illustration-pure-colors-card-item {
  position: relative;
  bottom: 0;  

  max-width: 1032px;
  width: 100%;
  height: 705px;

  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
.illustration-pure-colors-importante{
  display: flex;
  align-items: center;
}
</style>
